import { Button, Divider, Spin, message } from "antd";
import axios from "axios";
import React, { FC, useEffect, useState } from "react";

import styles from "@/components/Account/Address/Address.module.css";
import AddressEditForm from "@/components/Account/Address/AddressEditForm";
import PersonalInformationEditForm from "@/components/Account/PersonalInformation/PersonalInformationEditForm";
import { AddressData, IMAGES, addressSections } from "@/constant";
import { getUserData } from "@/services/Auth/AuthApi";
import { useAuthStore } from "@/stores/authStore";
import { GetCustomerData } from "@/types/authService";

export interface AddressInterface {
  AddressLine1: string;
  AddressLine2: string;
  AddressLine3: string;
  PostalCode: string;
}

export interface AddressDataTypeInterface {
  PermanentAddress: AddressInterface;
  CorrespondingAddress: AddressInterface;
}

const Address: FC = () => {
  const userId = useAuthStore((state) => state?.customer?.id);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [personalInfoData, setPersonalInfoData] = useState<GetCustomerData>();

  const getPersonalInfoHelper = async (): Promise<void> => {
    try {
      setLoading(true);
      const { data } = await getUserData();
      setPersonalInfoData(data);
    } catch (error: unknown) {
      if (axios.isAxiosError<{ message: string }>(error)) {
        message.error(error?.response?.data?.message || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void getPersonalInfoHelper();
  }, []);

  return (
    <div className={styles.mainContainer}>
      {loading ? (
        <Spin fullscreen />
      ) : (
        <>
          <div className={styles.headingSection}>
            {!isEdit && (
              <Button
                shape="default"
                icon={<img src={IMAGES.EDIT_ICON_BUTTON} alt="edit" />}
                className={styles.editButton}
                onClick={() => setIsEdit(!isEdit)}
              />
            )}
          </div>

          {isEdit && personalInfoData ? (
            <AddressEditForm
              onClose={(data?: AddressDataTypeInterface) => {
                void getPersonalInfoHelper();
                setIsEdit(false);
              }}
              editData={personalInfoData}
            />
          ) : (
            <div className={styles.personalInfoSection}>
              {addressSections.map((section) => (
                <div key={section.title} className={styles.sectionBlock}>
                  <Divider className={styles.headingText} orientation="left" orientationMargin="0">
                    <span className={styles.dividerText}>{section.title}</span>
                  </Divider>

                  <div className={styles.addressFields}>
                    {section.fields.map(({ label, key }) => {
                      const fieldKey = `${section.prefix}${key}`;
                      const value = personalInfoData?.[fieldKey as keyof GetCustomerData] || "-";

                      return (
                        <div key={fieldKey} className={styles.singleInfoWrapper}>
                          <div className={styles.infoTitle}>{label}</div>
                          <div className={styles.info} data-dd-privacy="mask">
                            {value}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Address;
